import styled from 'styled-components';
import { darkgrey, divider, grey, inactive, warningred, white } from 'styles/Colors';
import ReactSelect from 'react-select';
import React from 'react';
import DownIcon from 'components/icons/downIcon.svg';
import DownIconRed from 'components/icons/downIconRed.svg';
import { ReactComponent as DeleteIcon } from 'components/icons/deleteIcon.svg';

export const Dot = styled.span<{ visible?: boolean }>`
  display: ${(props) => (props.visible ? 'block' : 'none')};
  background-color: #fe9800;
  font-size: 11px;
  line-height: 15.4px;
  color: ${white};
  padding: 0 4px;
  border-radius: 34px;
  font-weight: 700;
  opacity: ${(props) => (props.visible ? 1 : 0)};

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -20px;
`;

export const EntryNumber = styled.span`
  width: 30px;
  float: left;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  color: ${grey};
  line-height: 12px;
`;

export const ControlIcons = styled.div`
  height: 32px;
  display: flex;
  align-items: center;

  &.greyed-out {
    opacity: 0.35;
    svg {
      cursor: default;
    }
  }

  svg {
    cursor: pointer;
  }
`;

export const DNDIcon = styled.div<{ draggable: boolean }>`
  display: flex;
  margin-left: 16px;

  svg {
    cursor: ${(props) => (props.draggable ? 'move' : 'not-allowed')};
  }
`;

export const JerseyNumber = styled.input`
  border: 1px solid #cdcdcd;
  width: 44px;
  height: 32px;
  font-size: 13px;
  line-height: 18.2px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding-left: 8px;
`;

export const StyledReactSelect = styled((props) => <ReactSelect {...props} />)`
  letter-spacing: 0.6px;
  width: 50px;
  display: flex;
  align-items: center;
  box-shadow: none;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 13px;
  line-height: 18.2px;
  height: 32px;
  margin-left: 12px;

  &.red {
    border: 1px solid ${warningred};
    .position-select__dropdown-indicator {
      background: url(${DownIconRed});
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .position-select__control {
    width: 100%;
    height: 32px;
    min-height: initial;
    border-radius: none;
    border: none;
    box-shadow: none;
    align-items: flex-end;
    cursor: pointer;
    background-color: initial;
    font-size: 18px;

    svg {
      display: none;
    }
  }

  .position-select__input {
    width: 100%;
    min-height: initial;
    border-radius: none;
    border: none;
    align-items: flex-end;
  }

  .position-select__menu {
    box-shadow: 0 -3px 10px 0 rgba(0, 0, 0, 0.12);
  }

  .position-select__menu-list {
    width: 76px !important;
    background-color: ${white};

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      margin-right: 10px;
      height: 50px;
      border-radius: 10px;
      background-color: ${grey};
    }
  }

  .position-select__single-value {
    text-align: center;
    font-size: 13px;
    width: 24px;
  }

  .position-select__value-container {
    padding-left: 6px;
    position: unset;
  }

  .position-select__placeholder {
    line-height: 32px;
  }

  .position-select__indicators-container {
    align-items: flex-end;
    padding: 0;
  }

  .position-select__indicator-separator {
    display: none;
  }

  .position-select__dropdown-indicator {
    transition: all 0.2s ease-in;
    padding: 0;
    height: 32px;
    width: 22px;
    background: url(${DownIcon});
    background-repeat: no-repeat;
    background-position: center;

    svg {
      display: none;
    }
  }

  .position-select__control--menu-is-open {
    .position-select__dropdown-indicator {
      transform: rotate(180deg);
    }
  }

  .position-select__option {
    background-color: ${white};
    &:hover {
      background-color: rgba(236, 105, 26, 0.1);
    }
    &.position-select__option--is-selected {
      background-color: rgba(236, 105, 26, 0.2);
      color: ${darkgrey};
    }
  }
`;

export const LineupPlayerWrapper = styled.div`
  height: 48px;
  border-bottom: 1px solid ${divider};
  padding: 10px 0;
  display: flex;
  background-color: ${white};
  align-items: center;
  justify-content: space-between;
  position: relative;

  &.locked-pitcher {
    border-top: 1px solid ${inactive};
    ${ControlIcons} {
      ${JerseyNumber} {
        bottom: 0px;
        right: 51px;
      }
    }
  }
`;

export const PlayerWrapper = styled.div`
  display: flex;
  align-items: center;

  div > span {
    width: 100px;

    @media (min-width: 992px) {
      width: 200px;
    }
    @media (min-width: 1200px) {
      width: 250px;
    }
  }
`;

export const StyledDeleteIcon = styled((props) => <DeleteIcon {...props} />)`
  margin-left: 16px;
`;

export const OptionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;
  justify-content: space-between;

  svg {
    width: 12px;
  }
`;
